import { cx, css } from 'emotion'

import AppCurrency from '@/components/App/AppCurrency'
import AppNumberWithUnit from '@/components/App/AppNumberWithUnit'
import AppCtr from '@/components/App/AppCtr'
import AppVideoCompletion from '@/components/App/AppVideoCompletion'

const MainTableDeliveryGroupRow = ({ props }) => {
  const { deliveryGroupReport, isHideRevenue } = props

  // 配信グループの表
  const backgroundBase3 = css`
    background: white;
  `
  const columnStyles = cx('campaign__column', backgroundBase3)

  return [
    <tr>
      <td class={columnStyles} />
      <td class={[columnStyles, 'text-xs-left']} style="padding-left: 40px">
        {deliveryGroupReport.deliveryGroupName}
      </td>
      <td class={[columnStyles, 'text-xs-center']} />
      {!isHideRevenue && <td class={[columnStyles, 'text-xs-left']} />}
      {!isHideRevenue && (
        <td class={columnStyles}>
          <AppCurrency value={deliveryGroupReport.revenueBuyingCurrency} />
        </td>
      )}
      <td class={columnStyles}>
        <AppNumberWithUnit value={deliveryGroupReport.imps} local-string />
      </td>
      <td class={columnStyles}>
        <AppNumberWithUnit value={deliveryGroupReport.clicks} local-string />
      </td>
      <td class={columnStyles}>
        <AppCtr value={deliveryGroupReport.ctr} />
      </td>
      {!isHideRevenue && (
        <td class={columnStyles}>
          <AppCurrency value={deliveryGroupReport.cpc} />
        </td>
      )}
      {!isHideRevenue && (
        <td class={columnStyles}>
          <AppCurrency value={deliveryGroupReport.cpm} />
        </td>
      )}
      {!isHideRevenue && (
        <td class={columnStyles}>
          <AppVideoCompletion
            value={deliveryGroupReport.videoCompletions}
            local-string
          />
        </td>
      )}
    </tr>,
  ]
}

export default MainTableDeliveryGroupRow
